import { GotradeConstant } from './constant.js';

// The Adjust link a CTA falls back to when it carries no paid deep link, keyed by the Adjust app
// kind of the page the CTA sits on ('gti' | 'gtg'), so a GTG page never hands out the GTI link.
// Anything that is not the GTI kind resolves to GTG, matching getCurrentAdjustAppKind's default.
export function appDownloadDefaultLink(appKind) {
  return appKind === 'gti'
    ? GotradeConstant.GTI_APP_DOWNLOAD_ADJUST_DEFAULT_LINK
    : GotradeConstant.GTG_APP_DOWNLOAD_ADJUST_DEFAULT_LINK;
}
